// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pl-0";